import { TextField } from "@material-ui/core";
import GoogleTagManager from "../../../gtm/GoogleTagManager";
import GtmFormularfeldId, { createGtmFieldId } from "../../../gtm/types/GtmFormularfeldId";
import StringUtil from "../../../app/util/StringUtil";
import MuiCss from '../../../assets/css/MuiCss';
import AdornmentState from './AdornmentState';
import InputEvents from "./InputEvents";

type Param = {
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    value?: string,
    label?: string,
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number,
    error?: boolean,
    helperText?: string,
    required?: boolean,
    placeholder?: string,
    maxLength?: number
}

const TextInputFieldMultiline: React.FC<Param> = ({ onBlur, onChange,
    value, label, id, idGtm, idGtmIndex, error, helperText, required, placeholder, maxLength }) => {

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const newValue = StringUtil.replaceCrossSiteScripting(value);
        event.target.value = newValue || '';
        onChange(event);
    }

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    return (
        <TextField id={id} label={label}
            classes={MuiCss.muiTextFieldModuleCss}
            color='primary'
            value={value}
            onFocus={handleOnFocus}
            onBlur={onBlur}
            onChange={handleOnChange}
            onKeyPress={InputEvents.preventOnKeyPressEnter}
            error={error}
            required={required}
            multiline
            InputProps={{
                classes: MuiCss.muiInputModuleCss,
                inputProps: {
                    inputMode: 'text',
                    wrap: 'soft',
                    maxLength: maxLength
                },
                endAdornment: <AdornmentState error={error} />
            }}
            InputLabelProps={{
                classes: MuiCss.muiInputLabelModuleCss
            }}
            helperText={helperText}
            placeholder={placeholder}
        />
    );
}

export default TextInputFieldMultiline;